import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BehfaRole_Interface } from 'src/app/Interface/BehfaRole_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BehfaRoleService {

  constructor(private http:HttpClient) { }

  GetRecord(Token:String):Observable<Array<BehfaRole_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/BehfaRole?token="+Token).pipe(
      map(data=>{
        return data as Array<BehfaRole_Interface>
      })
    )
  }

  GetSingle(Token:String,id:number):Observable<BehfaRole_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/BehfaRole/GetSingle?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as BehfaRole_Interface
      })
    )
  }

  AddBehfaRole(model: BehfaRole_Interface,Token:String):Observable<BehfaRole_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    model.create_user=Token

    var body={
      id:model.id,
      title:model.title,
      dsc:model.dsc,
      create_user:Token
    }

    return this.http.post(environment.BaseUrl + "Daro/BehfaRole/Add",body,{headers}).pipe(
      map(data=>{
        return data as BehfaRole_Interface
      })
    )
  }

  EditBehfaRole(model: BehfaRole_Interface,Token:String):Observable<BehfaRole_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body={
      id:model.id,
      title:model.title,
      dsc:model.dsc,
      create_user:Token
    }

    return this.http.post(environment.BaseUrl + "Daro/BehfaRole/Edit",body,{headers}).pipe(
      map(data=>{
        return data as BehfaRole_Interface
      })
    )
  }

  DeleteBehfaRole(id:number,Token:String):Observable<BehfaRole_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/BehfaRole/Delete?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as BehfaRole_Interface
      })
    )
  }

  PriorityBehfaRole(id:number,Token:String):Observable<BehfaRole_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/BehfaRole/Priority?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as BehfaRole_Interface
      })
    )
  }

}
